import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { InstitutionService } from "@service/institution.service";
import { UsersService } from "@service/admin/users.service";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";

@Component({
  selector: "app-modal-set-institution",
  templateUrl: "./modal-set-institution.component.html",
  styleUrls: ["./modal-set-institution.component.scss"],
})
export class ModalSetInstitutionComponent implements OnInit {
  public institutions = [];
  public selectedInstitutions = [];
  public institutionLoading: boolean = false;
  public isChecked: boolean = false;
  public isDataAvailable: boolean = false;
  userId: number;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [COMMA, ENTER];
  @ViewChild("institutionInput", { static: false })
  institutionInput: ElementRef<HTMLInputElement>;

  constructor(
    public activeModal: NgbActiveModal,
    private institutionService: InstitutionService,
    private usersService: UsersService
  ) {}

  ngOnInit() {
    this.institutionService.getInstitutions().subscribe((res) => {
      res.forEach((institution) => {
        this.institutions.push(institution.name);
      });
    });

    this.usersService.getPermissions(this.userId).subscribe((res) => {
      this.isChecked = res.is_institution;
      this.selectedInstitutions = res.institutions;
    });

    this.isDataAvailable = true;
  }

  onCheckboxChange(checked: boolean) {
    this.isChecked = checked;
  }

  save() {
    this.activeModal.close({
      checked: this.isChecked,
      institutions: this.selectedInstitutions,
    });
  }

  remove(institution: any): void {
    const index = this.selectedInstitutions
      .map((institution) => institution.id)
      .indexOf(institution.id);

    if (index >= 0) {
      this.selectedInstitutions.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.selectedInstitutions.push(event.option.value);
    this.institutionInput.nativeElement.value = "";
  }

  hasIncluded(institution) {
    return this.selectedInstitutions.map((s) => s.id).includes(institution.id);
  }
}
